import React, {Component} from 'react';

import ToggleInput from "../../../../../components/ToggleInput/toggleInput";
import formatters from "../../../../../utils/formatters";


export default class DischargeDone extends Component {

    componentDidMount() {}

    render() {
        let discharge = this.props.discharge;
        if(!discharge)return <div />;

        return (
            <div>
                <div className={"discharge-title-section"}>Controles Previos</div>
                <div className={"row"}>
                    <div className={"col s4"}>
                        <div style={{marginBottom: '30px'}}>
                            <ToggleInput
                                selected={discharge.clear_appearance_check}
                                name={'Aspecto Claro'} />
                            <ToggleInput
                                selected={discharge.seals_check}
                                name={'Precintos según remito'} />
                            <ToggleInput
                                selected={true}
                                name={'¿Se realizó la descarga a tierra?'} />
                        </div>
                        <div className={"input-field input-grey"}>
                            <label className="active">Temperatura medida (°C) s/mov.</label>
                            <p className={'field-p-no-border'}>
                                {formatters.floatFormat(discharge.terminal_sample_temperature)}
                            </p>
                        </div>
                        <div className={"input-field input-grey"}>
                            <label className="active">Densidad medida a temp. ambiente</label>
                            <p className={'field-p-no-border'}>
                                {formatters.floatFormat(discharge.terminal_sample_density)}
                            </p>
                        </div>
                    </div>
                    <div className={"col s4"}>
                        <div className={"discharge-control-box"}>
                            <div className={"discharge-control-box-title"}>Densidad a 20º (Kg/m3)</div>
                            <div className={"row discharge-control-box-body"}>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Según camion</label>
                                    <p className={'field-p-no-border'}>
                                        {formatters.floatFormat(discharge.origin_reference_density)}
                                    </p>
                                </div>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Según movimientos</label>
                                    <p className={'field-p-no-border'}>
                                        {formatters.floatFormat(discharge.terminal_reference_density)}
                                    </p>
                                </div>
                            </div>
                            <div className={"discharge-control-box-footer"}>
                                <div className={"row no-margin"}>
                                    <div className={"col s12 input-field"}>
                                        <label className="active">Diferencia</label>
                                        <p className={"field-p"}>
                                            <span className={`diff-text`}>{formatters.floatFormat(discharge.reference_density_diff)}</span>
                                            <i className="material-icons shell-red-text">error</i>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {(discharge.origin_alcoholic_grade || discharge.terminal_alcoholic_grade) &&
                    <div className={"col s4"}>
                        <div className={"discharge-control-box"}>
                            <div className={"discharge-control-box-title"}>Grado alcohólico (%)</div>
                            <div className={"row discharge-control-box-body"}>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Según camion</label>
                                    <p className={'field-p-no-border'}>
                                        {formatters.floatFormat(discharge.origin_alcoholic_grade)}
                                    </p>
                                </div>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Según movimientos</label>
                                    <p className={'field-p-no-border'}>
                                        {formatters.floatFormat(discharge.terminal_alcoholic_grade)}
                                    </p>
                                </div>
                            </div>
                            <div className={"discharge-control-box-footer"}>
                                <div className={"row no-margin"}>
                                    <div className={"col s12 input-field"}>
                                        <label className="active">Diferencia</label>
                                        <p className={"field-p"}>
                                            <span className={`diff-text`}>{formatters.floatFormat(discharge.alcoholic_grade_diff)}</span>
                                            <i className="material-icons shell-red-text">error</i>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
                <div className={'discharge-title-section no-margin'}>Descarga</div>
                <div className={'trip-fixed-information discharge-meter-info'}>
                    <div className={"row no-margin"}>
                        <div className={'col s3 input-field'}>
                            <label className="active">Operador</label>
                            <p className={"field-p-no-border"}>
                                {discharge.unload_operator.first_name} {discharge.unload_operator.last_name}
                            </p>
                        </div>
                        <div className={'col s3 input-field'}>
                            <label className="active">Turno</label>
                            <p className={"field-p-no-border"}>
                                {discharge.unload_operator_shift}
                            </p>
                        </div>
                        <div className={'col s6 input-field'}>
                            <label className="active">Meter</label>
                            <p className={"field-p-no-border"}>
                                {(discharge && discharge.meter && discharge.meter.loading_island) ?
                                    `${discharge.meter.loading_island.name} - ${discharge.meter.description}` : '-'
                                }
                            </p>
                        </div>
                    </div>
                </div>
                <div className={"row thin-row"}>
                    <div className={"col s6"}>
                        <ToggleInput
                            className={"no-margin"}
                            selected={discharge.meter_works}
                            name={'Meter funcionando'} />
                    </div>
                </div>
                <div className={'row margin-top-20'}>
                    <div className={'col s6'}>
                        <div className={'meter-box'}>
                            <div className={'meter-box-title'}>
                                <i className={"material-icons"}>play_circle_outline</i>
                                <div>Inicio</div>
                            </div>
                            <div className={'row no-margin meter-box-body'}>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Inicio - Meter</label>
                                    <p className={"field-p"}>
                                        {formatters.intFormat(discharge.initial_totalizer)}
                                    </p>
                                </div>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Hora de inicio</label>
                                    <p className={"field-p"}>
                                        {discharge.unload_started_at}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={'col s6'}>
                        <div className={'meter-box'}>
                            <div className={'meter-box-title'}>
                                <i className={"material-icons"}>pause_circle_outline</i>
                                <div>Fin descarga</div>
                            </div>
                            <div className={'row no-margin meter-box-body'}>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Fin - Meter</label>
                                    <p className={"field-p"}>
                                        {formatters.intFormat(discharge.final_totalizer)}
                                    </p>
                                </div>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Hora de finalización</label>
                                    <p className={"field-p"}>
                                        {discharge.unload_finished_at}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"row thin-row"}>
                    <div className={"col s6"}>
                        <ToggleInput
                            className={"no-margin"}
                            selected={true}
                            name={'¿Se vaciaron todas las cisternas?'} />
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 input-field input-grey"}>
                        <label className="active">Observaciones de la descarga</label>
                        <p className={"field-p"}>
                            {discharge.unload_observations}
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/Discharge/DischargeDone.js